import { useState } from "react";
import { Lock, Unlock } from "lucide-react";
import { ConfirmDialog } from "./ConfirmDialog";

export const isStopped = (cls) => cls?.classroom?.master_control === "stop";

export const MasterControl = ({ cls }) => {
  const [ask, setAsk] = useState(null);
  const c = cls.classroom;
  if (!c) return null;
  const stopped = c.master_control === "stop";
  const pick = (v) => { if ((v === "stop") !== stopped) setAsk(v); };
  return (
    <>
      <div data-testid="master-control" className={`inline-flex items-center gap-2 rounded-full border px-2 py-1.5 ${stopped ? "border-red-300 bg-red-50" : "border-emerald-300 bg-emerald-50"}`}>
        <span className={`pl-2 text-xs font-semibold uppercase tracking-wider flex items-center gap-1.5 ${stopped ? "text-red-700" : "text-emerald-800"}`}>{stopped ? <Lock size={13} /> : <Unlock size={13} />} Master Control</span>
        <div className="inline-flex rounded-full bg-white border border-border p-0.5" role="radiogroup" aria-label="Master Control">
          {[["open", "Open"], ["stop", "STOP"]].map(([v, l]) => {
            const active = stopped ? v === "stop" : v === "open";
            return <button key={v} type="button" role="radio" aria-checked={active} data-testid={`master-control-${v}`} onClick={() => pick(v)} className={`rounded-full px-4 py-1.5 text-xs font-bold transition-colors ${active ? (v === "stop" ? "bg-red-600 text-white" : "bg-emerald-600 text-white") : "text-muted-foreground hover:bg-muted"}`}>{l}</button>;
          })}
        </div>
      </div>
      <ConfirmDialog open={!!ask} testId="master-control-confirm" danger={ask === "stop"}
        title={ask === "stop" ? "STOP the classroom?" : "Open the classroom?"}
        confirmLabel={ask === "stop" ? "Yes, STOP" : "Yes, Open"} cancelLabel="No, cancel"
        lines={ask === "stop"
          ? ["Are you sure? Master Control STOP switches OFF Start Present Batch, participant and Guide video access and the Register Steps for Present Batch and Guides.", "Every option in section 13 Classroom is locked until you set Master Control back to Open. Your current settings are remembered."]
          : ["Are you sure? Master Control Open restores every option exactly as it was when you pressed STOP (Start Present Batch, video access, Register Steps).", "Participants and Guides regain access as per those settings."]}
        onCancel={() => setAsk(null)} onConfirm={() => { const v = ask; setAsk(null); cls.saveField("master_control", v); }} />
    </>
  );
};

export const MasterLock = ({ cls, children }) => {
  if (!isStopped(cls)) return children;
  return (
    <div data-testid="master-locked" className="relative">
      <div role="alert" className="mb-3 flex items-center gap-3 rounded-2xl border border-red-300 bg-red-50 px-4 py-3 text-red-800">
        <Lock size={18} className="shrink-0" />
        <p className="text-sm"><span className="font-semibold">Master Control is STOP.</span> All classroom options below are disabled and Register Steps are OFF for Present Batch and Guides. Set Master Control to Open to restore the remembered settings.</p>
      </div>
      <div aria-disabled="true" className="pointer-events-none select-none opacity-50 grayscale-[35%]">{children}</div>
    </div>
  );
};
